import qs from "qs";

export default params => qs.stringify(params, { arrayFormat: "brackets" });



// WEBPACK FOOTER //
// ./src/shadow-client/axios/paramsSerializer.js